
const STAGING_URL = 'http://3.109.244.146:3001';
const DEFAULT_PROD_URL = process.env.REACT_APP_BASE_URL || 'https://data.dayro.com';
const computeBaseURL = () => {
    try {
        return localStorage.getItem('dayro_server') === 'staging' ? STAGING_URL : DEFAULT_PROD_URL;
    } catch {
        return DEFAULT_PROD_URL;
    }
};
export const BASE_URL = { toString() { return computeBaseURL(); } };
export const IMAGE_URL = "https://data.dayro.com/s/avatar/"
const apiVersion = 1;

//LOGIN
export const SEND_OTP = `/admin/v${apiVersion}/user/send-otp`;
export const VERIFY_OTP = `/admin/v${apiVersion}/user/verify-otp`;

// LOGOUT
export const LOGOUT = `/admin/v${apiVersion}/user/logout`;

// AREA
export const GET_AREA_LIST_URL = `/admin-api/v${apiVersion}/city/list-area`;
export const GET_SEARCH_CITY_URL = `/admin-api/v${apiVersion}/city/search`;
export const ADD_AREA_URL = `/admin-api/v${apiVersion}/city/add-area`;
export const EDIT_AREA_URL = `/admin-api/v${apiVersion}/city/edit-area`;
export const DELETE_AREA_URL = `/admin-api/v${apiVersion}/city/delete-area`;

// CONTROL_PANEL
export const GET_ROOM_LIST_URL = `/admin-api/v${apiVersion}/room/list`;
export const GET_CONTROL_ROOM_LIST_URL = `/admin-api/v${apiVersion}/room/control-list`;
export const GET_SWITCH_LIST_URL = `/admin-api/v${apiVersion}/room/switches`;
export const REMOVE_GUEST_URL = `/admin-api/v${apiVersion}/room/remove-allow-room`;

// SUB_ADMIN
export const GET_SUB_ADMIN_URL = `/admin/v${apiVersion}/user/list-admin`;
export const ADD_SUB_ADMIN_URL = `/admin-api/v${apiVersion}/user/add-sub-admin`;
export const EDIT_SUB_ADMIN_URL = `/admin-api/v${apiVersion}/user/update-sub-admin`;
export const DELETE_SUB_ADMIN_URL = `/admin-api/v${apiVersion}/user/delete-sub-admin`;
export const REMOVE_ACCESS_URL = `/admin-api/v${apiVersion}/user/remove-user-access`;

// ROLE_MANAGEMENT
export const GET_ROLE_LIST_URL = `/admin-api/v${apiVersion}/role/list`;
export const ADD_ROLE_URL = `/admin-api/v${apiVersion}/role/add`;
export const EDIT_ROLE_URL = `/admin-api/v${apiVersion}/role/update`;
export const DELETE_ROLE_URL = `/admin-api/v${apiVersion}/role/delete`;
export const GET_ROLE_PERMISSION_LIST = `/admin-api/v${apiVersion}/role/get`;
export const TAG_PERMISSION_LIST = `/admin-api/v${apiVersion}/role/tag-permission`;
export const MENU_PERMISSION_LIST = `/admin-api/v${apiVersion}/role/menu-permission`;

// TAG_MANAGEMENT
export const GET_TAG_LIST_URL = `/admin-api/v${apiVersion}/tag/list`;
export const ADD_TAG_URL = `/admin-api/v${apiVersion}/tag/add`;
export const UNASSIGN_LIST_API_URL = `/admin-api/v${apiVersion}/room/unassigned`;
export const GET_AREA_ROOMS_URL = `/admin-api/v${apiVersion}/room/assigned`
export const ASSIGN_AREA_ROOMS_URL = `/admin-api/v${apiVersion}/room/assign-tag`
export const GET_SEARCH_TAG_URL = `/admin-api/v${apiVersion}/tag/search`
export const UPDATE_TAG_URL = `/admin-api/v${apiVersion}/tag/update`
export const DELETE_TAG_URL = `/admin-api/v${apiVersion}/tag/delete`

// SERVICE PERSON
export const GET_SERVICE_PERSON_URL = `/admin-api/v${apiVersion}/user/list-service-person`;
export const ADD_SERVICE_PERSON_URL = `/admin-api/v${apiVersion}/user/add-service-person`;
export const ALL_PREMISES_SEARCH_URL = `/admin-api/v${apiVersion}/premise/search-all`;
export const UPDATE_SERVICE_PERSON_URL = `/admin-api/v${apiVersion}/user/update-service-person`;
export const DELETE_SERVICE_PERSON_URL = `/admin-api/v${apiVersion}/user/delete-service-person`;
export const ACCESS_PREMISES_LIST_URL = `/admin-api/v${apiVersion}/user/list-user-access`;

// PREMISES
export const GET_PREMISE_LIST_URL = `/admin-api/v${apiVersion}/premise/list`;
export const ADD_PREMISE_URL = `/admin-api/v${apiVersion}/premise/add`;
export const ASSIGN_PREMISE_URL = `/admin-api/v${apiVersion}/user/assign-premise`;
export const GET_SEARCH_USER_URL = `/admin-api/v${apiVersion}/user/search`;
export const GET_SEARCH_AREA_URL = `/admin-api/v${apiVersion}/city/search-area`;
export const GET_SEARCH_PREMISE_URL = `/admin-api/v${apiVersion}/premise/search`;
export const GET_SEARCH_STATE_URL = `/admin-api/v${apiVersion}/city/search-state`;
export const GET_SEARCH_CITY_FROM_STATE_URL = `/admin-api/v${apiVersion}/city/search-city-from-state`;
export const SELECT_PREMISE_URL = `/admin-api/v${apiVersion}/premise/select-premise`;

// USERS
export const GET_USERS_LIST_URL = `/admin/v${apiVersion}/user/list-users`;
export const GET_USERS_DETAIL_URL = `/admin/v${apiVersion}/user/detail`;
export const GET_SWITCH_DETAIL_URL = `/admin/v${apiVersion}/user/switch-devices`;
export const GET_DEVICE_DETAIL_URL = `/admin/v${apiVersion}/user/device-switches`;
export const DELETE_USER = `/admin-api/v${apiVersion}/user/delete-user`;
export const RESET_PCB = `/admin/v${apiVersion}/user/reset-pcb`;
export const PING_DEVICE = `/admin/v${apiVersion}/user/ping-device`;

// Recycle bin (soft-deleted places)
export const RECYCLE_BIN_LIST = `/admin/v${apiVersion}/place/recycle-bin`;
export const RECYCLE_BIN_RESTORE = `/admin/v${apiVersion}/place/restore`;
export const RECYCLE_BIN_PURGE = `/admin/v${apiVersion}/place/purge`;
export const PING_PCB = `/admin/v${apiVersion}/user/ping-pcb`;
export const RESTART_PCB = `/admin/v${apiVersion}/user/restart-pcb`;
// Explicit per-module OTA (admin panel per-row button). Separate from the
// autonomous /trigger, which resolves its own target from the channel manifest.
export const OTA_TRIGGER_EXACT = `/admin/v${apiVersion}/ota/trigger-exact`;

// PROFILE_LIST
export const GET_PROFILE_LIST_DETAILS = `/admin-api/v${apiVersion}/user/detail`;
export const CHANGE_PREMISE_PRO = `/admin-api/v${apiVersion}/user/change-premise-pro`;
export const GET_CHIPS_LIST = `/admin-api/v${apiVersion}/user/chips`;
export const DELETE_CHIP = `/admin-api/v${apiVersion}/user/delete-user-chip`;
export const GET_BLASTER_LIST = `/admin-api/v${apiVersion}/user/blasters`;
export const DELETE_USER_BLASTER = `/admin-api/v${apiVersion}/user/delete-user-blaster`;
export const GET_SCHEDULE_LIST = `/admin-api/v${apiVersion}/user/schedules`;
export const GET_DEVICE_LIST = `/admin-api/v${apiVersion}/user/devices`;
export const GET_CHIP_LOG_LIST = `/admin-api/v${apiVersion}/user/chip-logs`;
export const GET_USER_ACTION_LIST = `/admin/v${apiVersion}/user/user-action`;
export const GET_CREATE_NETWORK = `/admin/v${apiVersion}/user/create-network`;
export const GET_NETWORK_LOGS = `/admin/v${apiVersion}/user/network-log-detail`;
export const GET_ONLINE_LOGS = `/admin/v${apiVersion}/user/online-log-detail`;
export const GET_SWITCH_ONLINE_LOGS = `/admin/v${apiVersion}/user/switch-online-log-detail`;

// POLLING (admin) — runtime kill-switch for the backend's status polling.
// Pause/resume globally or per place (network); per-place pause supports a TTL.
// See doc/admin-polling-and-health-api.md in the backend repo.
export const POLLING_STATUS = `/admin/v${apiVersion}/polling/status`;
export const POLLING_GLOBAL = `/admin/v${apiVersion}/polling/global`;
export const POLLING_PLACE = `/admin/v${apiVersion}/polling/place`;
export const POLLING_PLACE_ALLOW = `/admin/v${apiVersion}/polling/place-allow`;

// HEALTH (admin) — captured device health/diagnostics + TTL-boxed watches.
// See doc/admin-polling-and-health-api.md in the backend repo.
export const HEALTH_LIST = `/admin/v${apiVersion}/health/list`;
export const HEALTH_WATCH = `/admin/v${apiVersion}/health/watch`;
export const HEALTH_UNWATCH = `/admin/v${apiVersion}/health/unwatch`;
export const HEALTH_WATCHES = `/admin/v${apiVersion}/health/watches`;

// OTA (admin) — verification jobs, failures, and stragglers from the
// backend's OTA manager. See doc in the backend repo.
export const OTA_FAILED = `/admin/v${apiVersion}/ota/failed`;
export const OTA_STATUS = `/admin/v${apiVersion}/ota/status`;
export const OTA_STRAGGLERS = `/admin/v${apiVersion}/ota/stragglers`;
// Auto-update opt-in (phase 1, 2026-08-03): body {placeId, enabled, minutes?}.
// Under backend mode 'provisioning', membership grants FULL auto-OTA for the
// place (fw-report/reconnect/periodic triggers) — not just provisioning.
export const OTA_PLACE_ALLOW = `/admin/v${apiVersion}/ota/place-allow`;
// Auto-update EXEMPTION (phase 2, 2026-08-03): body {placeId, enabled, minutes?}.
// Deny is absolute — an exempted place receives NO automatic updates in ANY
// backend mode (beats 'on', provisioning lineage and the opt-in list above).
// Manual/admin-triggered OTA still works.
export const OTA_PLACE_DENY = `/admin/v${apiVersion}/ota/place-deny`;
// Per-place sequenced auto-update snapshot (engine, 2026-08-08).
export const OTA_PLACE_STATUS = `/admin/v${apiVersion}/ota/place-status`;
export const OTA_MIGRATE_STATUS = `/admin/v${apiVersion}/ota/migrate-status`;
// RETIRED — the backend answers 410 on this path (cefc99f, kept deliberately:
// master issuance is V2-owned and needs plan/request/audit context this panel
// does not have). Currently referenced by nothing. Do NOT wire a control to it;
// if the panel ever needs to show issuance, add an admin-authed READ endpoint.
export const OTA_MIGRATE_MASTER = `/admin/v${apiVersion}/ota/migrate-master`;

// HOTEL_USERS
export const GET_HOTEL_USERS_LIST_URL = `/admin-api/v${apiVersion}/user/list-hotel-user`;
export const ADD_HOTEL_USER_URL = `/admin-api/v${apiVersion}/user/add-hotel-user`;
export const UPDATE_HOTEL_USER_URL = `/admin-api/v${apiVersion}/user/update-hotel-user`;
export const REMOVE_HOTEL_USER_ROLE_PERMISSION = `/admin-api/v${apiVersion}/user/remove-hotel-user-role-access`;
export const DELETE_HOTEL_USER_URL = `/admin-api/v${apiVersion}/user/delete-hotel-user`;

// SETTINGS
export const GET_PROFILE_URL = `/admin-api/v${apiVersion}/user/profile`;
export const UPDATE_PROFILE_URL = `/admin-api/v${apiVersion}/user/update-profile`;

// DASHBOARD
export const GET_DASHBOARD = `/admin-api/v${apiVersion}/user/dashboard`;
export const ALLOW_ROOM = `/admin-api/v${apiVersion}/user/allow-room`;
export const UPDATE_ROOM = `/admin-api/v${apiVersion}/user/update-allow-room`;
export const SEARCH_GUEST_NAME_URL = `/admin-api/v${apiVersion}/user/search-guest`;
export const GET_ALLOW_ROOM_LIST_URL = `/admin-api/v${apiVersion}/user/list-for-allow`;

// ADMIN-DASHBOARD
export const GET_DASHBOARD_DATA = `/admin/v${apiVersion}/user/dashboard`
// Fleet charts (Ram 2026-08-04): fw split per SKU + freshness + OTA jobs summary
export const GET_DASHBOARD_CHARTS = `/admin/v${apiVersion}/user/dashboard-charts`
// Production funnel (Ram 2026-08-04): board QC -> assembly -> tests -> deployment
export const GET_PRODUCTION_FUNNEL = `/admin/v${apiVersion}/user/production-funnel`
export const GET_REAL_TIME_DATA = `/admin-api/v${apiVersion}/user/real-time-data`
export const GET_ONLINE_CHIP_DATA = `/admin-api/v${apiVersion}/user/online-chips`
export const GET_OFFLINE_CHIP_DATA = `/admin-api/v${apiVersion}/user/offline-chips`
export const GET_MQTT_DATA = `/admin-api/v${apiVersion}/user/mqtt-count`

// REQUESTED-DASHBOARD
export const GET_USER_DEVICE_DATA = `/admin-api/v${apiVersion}/user/user-device-data`

// LOGS
export const SEARCH_WEB_USER_URL = `/admin/v${apiVersion}/user/search-web-user`

// HOTEL USER APP
export const GET_HOTEL_USER_PERMISSIONS = `/admin-api/v${apiVersion}/user/get-permission`;

// STATIC-OTP
export const GET_STATIC_OTP_LIST = `/admin/v${apiVersion}/otp/list`;
export const ADD_STATIC_OTP = `/admin/v${apiVersion}/otp/add`;
export const DELETE_STATIC_OTP = `/admin/v${apiVersion}/otp/delete`;

// SEND-NOTIFICATION
export const SENT_NOTIFICATION_LIST = `/admin-api/v${apiVersion}/notification/list`;
export const SENT_NOTIFICATION = `/admin-api/v${apiVersion}/notification/send`;

// FIRMWARE
export const FIRMWARE_LIST = `/admin-api/v${apiVersion}/hardware/firmware-list`;
export const GET_HARDWARE_LIST = `/admin-api/v${apiVersion}/hardware/list`;
export const UPLOAD_BIN_FILE = `/admin-api/v${apiVersion}/hardware/update-bin`;
export const SAVE_FIRMWARE = `/admin-api/v${apiVersion}/hardware/save-firmware`;
export const PUSH_FIRMWARE_LIST = `/admin-api/v${apiVersion}/hardware/release-firmware-list`;
export const SEARCH_FIRMWARE_LIST = `/admin-api/v${apiVersion}/hardware/firmware-search`;
export const PUSH_FIRMWARE = `/admin-api/v${apiVersion}/hardware/release-firmware`;

// SCHEDUlEL-LOGS
export const SCHEDULES_LIST = `/admin-api/v${apiVersion}/user/schedules-logs`;

// DEBUG-DEVICE
export const GET_DEBUG_LIST = `/admin/v${apiVersion}/debug/list`;
export const ADD_DEBUG_CHIP = `/admin/v${apiVersion}/debug/add`;
export const DELETE_DEBUG_CHIP = `/admin/v${apiVersion}/debug/delete`;
export const DEBUG_DETAIL_LIST = `/admin/v${apiVersion}/debug/detail`;

// GUEST MANAGEMENT
export const GUEST_LIST_URL = `/admin-api/v${apiVersion}/room/guest-list`;
export const ADD_GUEST_URL = `/admin-api/v${apiVersion}/room/add-guest`;

// GUEST HISTORY
export const GUEST_HISTORY_LIST_URL = `/admin-api/v${apiVersion}/room/guest-history`;

// FEEDBACK
export const GUEST_FEEDBACK_URL = `/admin-api/v${apiVersion}/feedback/list`;
export const CHANGE_STATUS_URL = `/admin-api/v${apiVersion}/feedback/change-status`;

// BACKUP
export const GET_BACKUP_LIST_URL = `/admin-api/v${apiVersion}/backup/list`;
export const GET_BACKUP_RESTORE_URL = `/admin-api/v${apiVersion}/backup/restore`;

// TEST UTILITIES — app-side /api/v1 endpoints used by staging test wizard
export const APP_SEND_OTP = `/api/v${apiVersion}/user/send-otp`;
export const APP_PROFILE = `/api/v${apiVersion}/user/profile3`;
export const APP_VERIFY_OTP = `/api/v${apiVersion}/user/verify-otp`;
export const APP_ADD_PLACE = `/api/v${apiVersion}/place/add`;
export const APP_DELETE_PLACE = `/api/v${apiVersion}/place/delete`;
export const APP_ADD_ROOM = `/api/v${apiVersion}/room/add`;
export const APP_ADD_RELAY = `/api/v${apiVersion}/relay/add`;
export const APP_GET_LAST_UNICAST = `/api/v${apiVersion}/place/get-last-assigned-unicast-address`;
export const APP_UPDATE_LAST_UNICAST = `/api/v${apiVersion}/place/update-last-assigned-unicast-address`;
